/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1StatsByDateOverviewResponse } from '../../entities/v1/StatsByDateOverviewResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1OverviewModelSchema } from './overviewModelSchema'
import { z } from 'zod'

export const v1StatsByDateOverviewResponseSchema = z.object({
  overview: z.lazy(() => v1OverviewModelSchema),
}) as unknown as ToZod<V1StatsByDateOverviewResponse>